

import tinycolor from 'tinycolor2'
import defaultsDeep from 'lodash/defaultsDeep'
import cloneDeep from 'lodash/cloneDeep'
import {defaultTheme} from './defaultTheme'

export function getComputedTheme(themeOptions = {}) {
  const {primary, secondary} = themeOptions.colors || {}

  let computedColors = {colors: getComputedThemeColors(primary, secondary)}

  let computedTheme = defaultsDeep(cloneDeep(themeOptions), computedColors, cloneDeep(defaultTheme))

  // Merge header general header options with transparent header options
  defaultsDeep(computedTheme.header.transparent, computedTheme.header.general)

  return computedTheme
}

export function getComputedThemeColors(primary, secondary)  {
  
  let colors = {}

  if(primary) {
    colors = {
      primaryDark: tinycolor(primary).darken(15).toHslString(),
      primaryLight: tinycolor(primary).lighten(15).toHslString(),
      primary50: tinycolor(primary).setAlpha(0.5).toHslString()
    }
  }

  if(secondary) {
    colors = {...colors,
      secondaryDark: tinycolor(secondary).darken(15).toHslString(),
      secondaryLight: tinycolor(secondary).lighten(15).toHslString(),
      secondary50: tinycolor(secondary).setAlpha(0.5).toHslString()
    }
  }

  return colors

}

export function getComputedThemeColor(themeColors = {}, color) { 

  tinycolor(color).toHslString()

  const themeColorMatch = Object.entries(themeColors).find(
    ([ themeColorKey, themeColor ]) => tinycolor(color).toHslString() === tinycolor(themeColor).toHslString()
  )

  if (themeColorMatch) {
    const [ themeColorKey ] = themeColorMatch

    return `var(--color-${themeColorKey})`
  } else {
    return color
  }
}

export function compareColors(color1, color2)  {

  if ( tinycolor(color1).toHslString() == tinycolor(color2).toHslString() ) {
    return true
  } else {
    return false
  }

}
